import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { Spacing, Colors } from '@/shared/theme';
import { Title, Text } from '@/shared/ui';

import iconChevronDown from '@/assets/images/Landing/icon-chevron-down.svg';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: ${Spacing.x4}px;
  padding-top: ${Spacing.x5}px;
  width: 100%;
`;

const FAQList = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${Spacing.x2}px;
  width: 100%;
`;

const FAQItem = styled.div`
  display: flex;
  flex-direction: column;
  background-color: ${Colors.backgroundAlt};
  border-radius: 8px;
  overflow: hidden;
`;

const FAQHeader = styled.button`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: ${Spacing.x1_5}px;
  padding: ${Spacing.x2}px;
  background: none;
  border: none;
  cursor: pointer;

  &:hover {
    opacity: 0.8;
  }
`;

const FAQAnswer = styled.div<{ $isOpen: boolean }>`
  display: ${({ $isOpen }) => ($isOpen ? 'block' : 'none')};
  padding: 0 ${Spacing.x2}px ${Spacing.x2}px;
`;

const FAQChevron = styled.img<{ $isOpen: boolean }>`
  width: 24px;
  height: 24px;
  flex-shrink: 0;
  transition: transform 0.2s ease;
  transform: ${({ $isOpen }) => ($isOpen ? 'rotate(180deg)' : 'rotate(0deg)')};
`;

const FAQ_ITEMS = ['faq-q1', 'faq-q2', 'faq-q3'];
const FAQ_ANSWERS = ['faq-a1', 'faq-a2', 'faq-a3'];

const FAQSection = () => {
  const { t } = useTranslation();
  const [openFAQIndex, setOpenFAQIndex] = useState<number | null>(null);
  const toggleFAQ = (index: number) => {
    setOpenFAQIndex((prev) => (prev === index ? null : index));
  };
  return (
    <Container id="faq">
      <Title size="h3" bold centered>
        {t('landing.faq-title')}
      </Title>
      <FAQList role="list" aria-label={t('landing.faq-title')}>
        {FAQ_ITEMS.map((questionKey, index) => (
          <FAQItem key={questionKey} role="listitem">
            <FAQHeader
              onClick={() => toggleFAQ(index)}
              aria-expanded={openFAQIndex === index}
              aria-controls={`faq-answer-${index}`}
            >
              <Text size="p1" bold>
                {t(`landing.${questionKey}`)}
              </Text>
              <FAQChevron
                src={iconChevronDown}
                alt=""
                aria-hidden="true"
                $isOpen={openFAQIndex === index}
              />
            </FAQHeader>
            <FAQAnswer
              id={`faq-answer-${index}`}
              $isOpen={openFAQIndex === index}
              role="region"
              aria-labelledby={`faq-question-${index}`}
            >
              <Text size="p2">{t(`landing.${FAQ_ANSWERS[index]}`)}</Text>
            </FAQAnswer>
          </FAQItem>
        ))}
      </FAQList>
    </Container>
  );
};

export default FAQSection;
